import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { HtmlContainerElement } from "../HTMLComponents/Elements/HtmlContainerElement";
import { ILoadingElement } from "../Components/Elements/Interfaces/ILoadingElement";
import { PreloaderProvider } from "../Components/Managers/PreloaderProvider";
import { SplashScreen } from "./SplashScreen";
import { Strings } from "../../Common/Strings";
import { Languages } from "../Utils/Languages";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlSplashScreen extends HtmlContainerElement implements ILoadingElement {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    public static RequiredLoadGroup: string = "SPLASH";

    public static suspendInit: boolean = false;

    private static instance: HtmlSplashScreen = null;

    private _gameProgressBar: HTMLElement;
    private _gameProgressNumber: HTMLElement;
    private _gameContinueButton: HTMLElement;

    private _callback: () => void;
    private _keyboardEvent: () => void;

    //******************************************************************************************************************
    //  CREATE & INIT
    //******************************************************************************************************************

    create(node: Element): void {
        if (!PreloaderProvider.isGroupLoaded(HtmlSplashScreen.RequiredLoadGroup)) {
            return;
        }

        super.create(node);

        PreloaderProvider.addLoadingElementFunction(this);
        this._initialize();
        this.instance.offsetWidth;
        this.instance.classList.remove("_disabled");

        HtmlSplashScreen.suspendInit = true;
        HtmlSplashScreen.instance = this;

        SplashScreen.createSplashScreen(this);
    }

    private _initialize(): void {
        this._gameProgressBar = document.getElementById("splashProgressBar");
        this._gameProgressNumber = document.getElementById("splashProgressNumber");
        this._gameContinueButton = document.getElementById("splashScreen"); //used whole splash as a continue button

        if (this._gameProgressBar != null) {
            let progressBar = document.getElementById("progressBar");

            if (progressBar != null) {
                this._gameProgressBar.style.width = progressBar.style.width;
            }
        }

        if (this._gameProgressNumber != null) {
            let progressNumber = document.getElementById("progressNumber");

            if (progressNumber != null) {
                this._gameProgressNumber.textContent = progressNumber.textContent;
            }
        }
    }

    //******************************************************************************************************************
    //  LOAD COMPLETED
    //******************************************************************************************************************

    public showContinueButton(callback: () => void): void {
        this._callback = callback;

        if (this._callback != null) {
            if (this._gameContinueButton != null) {
                this._gameContinueButton.addEventListener("click", this._callback);
            }

            this._keyboardEvent = this.onKeyUp.bind(this);
            document.addEventListener("keyup", this._keyboardEvent);
        }
        this.instance.classList.add("_loaded");
    }

    private onKeyUp(event: KeyboardEvent): void {
        if (event.keyCode == 32) {
            document.removeEventListener("keyup", this._keyboardEvent);

            if (this._callback != null) {
                this._callback();
            }
        }
    }

    public hideSplashScreen(): void {
        if (this.instance.parentElement) {
            document.removeEventListener("keyup", this._keyboardEvent);
            this.instance.parentElement.removeChild(this.instance);
        }
    }

    public showError(): void {
        this.instance.classList.add("_error");

        let progressNumber = document.getElementById("splashProgressBar");
        progressNumber.innerHTML = Strings.loaded
            ? Languages.getRid("ERROR_404")
            : "Internal error. Please contact support.";
    }

    //******************************************************************************************************************
    //  PRELOADER EVENTS
    //******************************************************************************************************************

    public onLoadCompleted(success: boolean): void {
        //handle load completed in GameManager initReceived
    }

    public onProgressUpdate(progress: number): void {
        if (this._gameProgressBar != null) {
            this._gameProgressBar.style.width = progress + "%";
        }

        if (this._gameProgressNumber != null) {
            this._gameProgressNumber.textContent = progress + "%";
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/HtmlSplashScreen.ts
 **/